import React, {useState} from 'react';
import {greyishBlue100} from "assets/jss/main";

function StyledCard({style, noHoverShadow = false, ...props}) {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                padding: '16px',
                borderRadius: '8px',
                border: `1px solid ${greyishBlue100}`,
                backgroundColor: '#ffffff',
                ...!noHoverShadow && hovered && {
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1)',
                    transitionProperty: 'box-shadow',
                    transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
                    transitionDuration: '.15s'
                },
                ...style
            }}
            {...props}
        >
            {props.children}
        </div>
    );
}

export default StyledCard;
